import {Fragment} from "react";
import { Helmet } from 'react-helmet';
import "./css/servicios.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faDownload} from "@fortawesome/free-solid-svg-icons";
import BannerDatos from "../../images/servicio/bg-cloud.webp";
import BannerDatosmobile from "../../images/servicio/bg-cloud-m.webp";
import {Server} from "../../constants";

function InfoRescueSheets() {
    return (
        <Fragment>
            <Container fluid={true} className="banner-servicios">
                <Row>
                    <Col md={12} className="px-0">
                        <Helmet>
                            <link rel="preload" href={BannerDatos} as="image" />
                        </Helmet>
                        <Card>
                            <img
                                src={BannerDatos}
                                alt="Hyundai Banner"
                                className="card-bannerdatos"
                            />
                            <Card.Img
                                src={BannerDatosmobile}
                                alt="Hyundai Banner"
                                className="d-block d-sm-none"
                            />
                            <Card.ImgOverlay className="d-flex">
                                <Card.Title className="bg-banner-servicios w-100 d-flex align-items-center">
                                    <div className="mx-auto w-100">
                                        <h1 className="servicios-banner-titulo">
                                            Rescue Sheets
                                        </h1>
                                    </div>
                                </Card.Title>
                            </Card.ImgOverlay>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <Container className="mb-5 pb-3 mt-4 tabla-manual">
                <Row className="mt-5 mb-5">
                    <Col className="text-center">
                        <h5 className="h-txt-r">Una hoja de rescate (rescue sheet) brinda información vital y necesaria
                            en caso de accidentes, brindando a los servicios de emergencia, como bomberos o paramédicos,
                            datos precisos para realizar misiones de rescate u otras operaciones de una manera más
                            eficiente y
                            segura.</h5>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table responsive bordered hover>
                            <thead>
                            <tr>
                                <th>Vehículo</th>
                                <th>Tipo</th>
                                <th>Hoja de rescate</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td><h4 className="h-head-l">TUCSON</h4></td>
                                <td><h4 className="h-head-l">SUV</h4></td>
                                <td>
                                    <a
                                        href={`${Server}/documentos/rescue-sheets/Hyundai_TUCSON_SUV_2020_5d_GD_ES.PDF`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="manual-link"
                                    >
                                        PDF (ES) | 1.45 MB | Descargar
                                        <FontAwesomeIcon icon={faDownload}/>
                                    </a>
                                    <br/>
                                    <a
                                        href={`${Server}/documentos/rescue-sheets/Hyundai_TUCSON__SUV_2020_EN.PDF`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="manual-link"
                                    >
                                        PDF (EN) | 1.27 MB | Descargar
                                        <FontAwesomeIcon icon={faDownload}/>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
}
export default InfoRescueSheets;